import { render, staticRenderFns } from "./TaskAreaView.vue?vue&type=template&id=7028b44d&"
import script from "./TaskAreaView.vue?vue&type=script&lang=js&"
export * from "./TaskAreaView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports